import { ActionOrTriggerListTypeEnum, appPackagesStore, IActionOrTriggerListPageParams } from "@app/static/"
import { AppIcon30 } from '@app/ui'
import { toProxy } from "@fanfanlo"
import { Box, Button, Grid2, Typography } from "@mui/material"
import { useRouter } from "next/router"
import { PropsWithChildren, useEffect } from "react"
import { childToProjectDataUtils, IChildToProjectData } from "../../../utils"
import { actionOpenAppUtils, IActionOpenAppData } from "./IActionOpenApp.inft"

function UpdateAppLink({data, children}: {data: IActionOpenAppData}&PropsWithChildren){
    const projectInfo:IChildToProjectData = {}
    childToProjectDataUtils.actionList.getActionListByProp(data, projectInfo)
    if(!projectInfo.project?.id || !projectInfo.triggerActionGroup?.id || !projectInfo.triggerAction?.id || !projectInfo.actionGroup?.id){
        console.error('UpdateAppLink projectInfo is undefined', projectInfo)
        return
    }
    const router = useRouter()
    const backPath = router.pathname
    const query:IActionOrTriggerListPageParams = {
        backPath,
        projectId: projectInfo.project?.id,
        triggerActionGroupId: projectInfo.triggerActionGroup?.id,
        triggerActionId: projectInfo.triggerAction?.id,
        actionGroupId: projectInfo.actionGroup?.id,
        type: ActionOrTriggerListTypeEnum.updateAction,
        actionId: data.id,
        actionType: actionOpenAppUtils.type,
    }
    
    const param = new URLSearchParams([...Object.entries(query) as [string, string][]])
    const p = `/action-list/app-selector?${param.toString()}`
    useEffect(()=>{
        router.prefetch(p)
        // console.log('ppppppppprefectech', p)
    }, [])
    function onLinkClick(){
        router.push(p)
    }
    return <Button
    id="open-app-action-change-app-btn"
    data-id="open-app-action-change-app-btn"
    onClick={onLinkClick}>
        {children}
    </Button>
}
export function IActionOpenAppUI(data: IActionOpenAppData) {
    const packageInfo = appPackagesStore.findPackageInfoByPackageName(data.javaData.packageName)

    function onDeleteComfirmed(){
        const projectData:IChildToProjectData = {} 
        childToProjectDataUtils.actionList.getActionListByProp(data, projectData)
        const list = projectData.actionList
        if(!list){
            throw new Error('actionList is undefined')
        }
        const index = list.findIndex(a => a.id === data.id)
        if(index === -1){
            throw new Error('action not found')
        }
        toProxy(list).splice(index, 1)
    }
    return <Box sx={{ width: '100%' }}>
        <Box>
            <b>打开应用</b>
        </Box>
        <Grid2 container sx={{ width: '100%' }}>
            <Grid2 size="grow" container>
                <Grid2>
                    <AppIcon30 packageName={data.javaData.packageName} />
                </Grid2>
                <Grid2>
                    <Typography sx={{}}>
                        <span style={{display:"inline-block", textIndent: "10px" }}>{packageInfo?.label}</span>
                        <span style={{ display:"inline-block", textIndent: "10px", fontSize: "0.8rem" }}>{packageInfo?.packageName}</span>
                    </Typography>
                </Grid2>
            </Grid2>
            <Grid2 size={"auto"}>
                <UpdateAppLink data={data}>
                    <span>更换</span>
                </UpdateAppLink>
               
            </Grid2>
        </Grid2>
    </Box>
}